import { Component } from '@angular/core';

/** Coquille : barre de titre + assistant ajout / connexion accès logiciel caisse. */
@Component({
  selector: 'app-acces-logiciel-caisse-add-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>',
})
export class AccesLogicielCaisseAddShellComponent {}
